export class Logger {
  constructor(private tag: string) {
    this.tag = `[${this.tag}]`;
  }

  private getDate() {
    return new Date().toISOString();
  }

  public log(...args) {
    console.log(this.getDate(), this.tag, ...args);
  }

  public error(...args) {
    console.error(this.getDate(), this.tag, ...args);
  }
}
